export default __webpack_public_path__ + "static/media/66t.27f33ea6.jpg";